import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import styles from './MidTermReserveContainer.module.scss';
import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { useOpenLoginModal } from '@/hooks/useOpenLoginModal';
import Modal from '@/components/UI/modal/Modal';
import RequestVisit from '@/components/houses/_reusable/requestVisit/RequestVisit';
const MidTermReserveContainer = ({
  onSendReserveRequestClick,
  loading,
  hasVisitRequest
}) => {
  const {
    bootstrapData,
    requestToVisit,
    basicFilters
  } = useSelector(state => ({
    bootstrapData: state.bootstrapData,
    requestToVisit: state.requestToVisit,
    basicFilters: state.basicFilters
  }));
  const hasActiveRequest = hasVisitRequest || requestToVisit.data;
  const {
    setLoginDrawerState
  } = useOpenLoginModal();
  const [openRequestReserve, setOpenRequestReserve] = useState(false);
  const haveActivevisitRequest = useRef(false);
  const isLoggedIn = !!bootstrapData?.data?.user_info?.uid;
  useEffect(() => {
    if (isLoggedIn && haveActivevisitRequest.current) {
      setOpenRequestReserve(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);
  const handleRequestModal = () => {
    if (!isLoggedIn) {
      setLoginDrawerState({
        open: true,
        message: 'برای ادامه لطفا وارد شوید.'
      });
      haveActivevisitRequest.current = true;
    } else {
      setOpenRequestReserve(true);
    }
  };
  return <Box data-sentry-element="Box" data-sentry-component="MidTermReserveContainer" data-sentry-source-file="MidTermReserveContainer.tsx">
      <Modal open={openRequestReserve} onClose={() => setOpenRequestReserve(false)} data-sentry-element="Modal" data-sentry-source-file="MidTermReserveContainer.tsx">
        <RequestVisit open={openRequestReserve} onClose={() => setOpenRequestReserve(false)} data-sentry-element="RequestVisit" data-sentry-source-file="MidTermReserveContainer.tsx" />
      </Modal>

      <Box className={styles['midterm-button-container']} data-sentry-element="Box" data-sentry-source-file="MidTermReserveContainer.tsx">
        <Button disabled={!basicFilters?.checkout || loading} loading={loading} onClick={onSendReserveRequestClick} format="primary" data-sentry-element="Button" data-sentry-source-file="MidTermReserveContainer.tsx">
          ثبت رزرو
        </Button>
      </Box>
    </Box>;
};
export default MidTermReserveContainer;